<template>
  <p class="is-size-7">
    <span class="has-text-grey-light">Don't have a Mobile Number?</span>
    <BaseCollapsible>
      <template slot-scope="{toggleCollapsible}" slot="collapsibleTrigger">
        <a tabindex="0" aria-label="If you don't have a mobile number click here." @click="toggleCollapsible" @keydown.enter="toggleCollapsible" class="tp-link">Click Here</a>
      </template>

      <template slot="collapsibleContent">
        <div>
          <p tabindex="0">
            Our online ordering system requires the use of a mobile number so we can send you a secure login PIN, like your bank. When you log in to your account, you can see your order progress tracker in real time. If you do not have a mobile phone or would prefer not to use your mobile phone for mobile ordering, please call this store at:
            <a
              class="tp-link"
              :href="`tel:${location.contactPhone}`"
            >{{formatPhone(location.contactPhone)}}</a>.
          </p>
          <br>
          <p tabindex="0">You will still earn the same points if you order online, call the store or visit us.
            <br>We're happy to serve and reward you on every channel!
          </p>
        </div>
      </template>
    </BaseCollapsible>
  </p>
</template>

<script>
import phoneValidatorMixin from "@/components/mixins/phoneValidatorMixin";
import { LOCATION } from "@/stores/defs";
import { mapGetters } from "vuex";

export default {
  mixins: [phoneValidatorMixin],
  computed: {
    ...mapGetters({
      location: LOCATION.GET_LOCATION
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/account/PhonelessUserCollapsible.vue